import { AccountIntegration, Listing__c, Listing__c_Missing, ListingsProduct } from './listings.interfaces';

const AMAZON_US_INTEGRATION_ID = 'a031N00000pSy9GQAS'
const AMAZON_MEX_INTEGRATION_ID = 'a031N00000pSy92QAC'
const AMAZON_CA_INTEGRATION_ID = 'a031N00000pSy90QAC'

const AMAZON_INTEGRATION_IDS = [
  AMAZON_CA_INTEGRATION_ID,
  AMAZON_MEX_INTEGRATION_ID,
  AMAZON_US_INTEGRATION_ID
]

export function isPendingEnable(listing: Listing__c){
  const invalids = []
  if(listing.Product__r.Marketing_Status__c !== '4: Live'){
    invalids.push('Product marketing status is not "4: Live".')
  }
  if(!listing.Integration__r?.Country__c){
    invalids.push('Integration country is missing.')
  }
  if(listing.Integration__r?.Country__c){
    for(const country of listing.Product__r?.Unauthorized_Countries__c?.split(';') ?? []){
      if(country.includes(listing.Integration__r.Country__c)){
        invalids.push(`Product is unauthorized to sell in ${listing.Integration__r.Country__c}.`)
      }
    }
  }
  if(listing.Inventory_Status__c !== 'Enabled'){
    invalids.push('Listing inventory status is not "Enabled".')
  }
  return invalids
}

export function determineListingsToCreate(products: ListingsProduct[], accountIntegration: AccountIntegration, listings: Listing__c[]): Listing__c_Missing[] {
  const listingsToCreate: Listing__c_Missing[] = []
  for(const product of products){
    if(product.Marketing_Status__c?.includes('3:') || product.Marketing_Status__c?.includes('4:')){
      const sku = !product.MPN__c ? product.Secondary_SKU__c : product.MPN__c
      const upc = !product.UPC__c ? product.Secondary_UPC__c : product.UPC__c
  
      let amazonAbbreviation = ''
      if(accountIntegration.Order_Integration__c === AMAZON_CA_INTEGRATION_ID){
        amazonAbbreviation = '-CA'
      } else if(accountIntegration.Order_Integration__c === AMAZON_MEX_INTEGRATION_ID){
        amazonAbbreviation = '-MX'
      }
  
      const name = `${sku}${amazonAbbreviation}${accountIntegration.Order_Integration__r.Listing_Name_Suffix__c}`
      const existingListing = listings?.find(l => l.Product__c === product.Id && !l.Name.includes('-FBA'))

      if(!existingListing){
        listingsToCreate.push({
          Name: name,
          Integration__c: accountIntegration.Order_Integration__c,
          Product__c: product.Id,
          SKU__c: `${sku}${amazonAbbreviation}`,
          UPC__c: upc,
          temp: {
            Product: product
          }
        })
      }
      /** Add an additional FBA listing if Amazon */
      if(AMAZON_INTEGRATION_IDS.includes(accountIntegration.Order_Integration__c)){
        const fbaName = `${product.MPN__c}-FBA${accountIntegration.Order_Integration__r.Listing_Name_Suffix__c}`
        const existingFbaListing = listings?.find(l => l.Product__c === product.Id && l.Name.includes('-FBA'))
        if(!existingFbaListing){
          listingsToCreate.push({
            Name: fbaName,
            Integration__c: accountIntegration.Order_Integration__c,
            Product__c: product.Id,
            SKU__c: `${sku}-FBA`,
            UPC__c: upc,
            Inventory_Status__c: 'Disabled',
            temp: {
              Product: product
            }
          })
        }
      }
    }
  }

  return listingsToCreate
}

export function determineListingsToCreateByProduct(product: ListingsProduct, accountIntegrations: AccountIntegration[], listings: Listing__c[]): Listing__c_Missing[] {
  const listingsToCreate: Listing__c_Missing[] = []
  for(const accountIntegration of accountIntegrations){
    if(product.Marketing_Status__c?.includes('3:') || product.Marketing_Status__c?.includes('4:')){
      const sku = !product.MPN__c ? product.Secondary_SKU__c : product.MPN__c
      const upc = !product.UPC__c ? product.Secondary_UPC__c : product.UPC__c
  
      let amazonAbbreviation = ''
      if(accountIntegration.Order_Integration__c === AMAZON_CA_INTEGRATION_ID){
        amazonAbbreviation = '-CA'
      } else if(accountIntegration.Order_Integration__c === AMAZON_MEX_INTEGRATION_ID){
        amazonAbbreviation = '-MX'
      }
  
      const name = `${sku}${amazonAbbreviation}${accountIntegration.Order_Integration__r.Listing_Name_Suffix__c}`
      const existingListing = listings?.find(l => l.Product__c === product.Id && l.Integration__c === accountIntegration.Order_Integration__c && !l.Name.includes('-FBA'))

      if(!existingListing){
        listingsToCreate.push({
          Name: name,
          Integration__c: accountIntegration.Order_Integration__c,
          Product__c: product.Id,
          SKU__c: `${sku}${amazonAbbreviation}`,
          UPC__c: upc,
          temp: {
            Product: product
          }
        })
      }
      /** Add an additional FBA listing if Amazon */
      if(AMAZON_INTEGRATION_IDS.includes(accountIntegration.Order_Integration__c)){
        const fbaName = `${product.MPN__c}-FBA${accountIntegration.Order_Integration__r.Listing_Name_Suffix__c}`
        const existingFbaListing = listings?.find(l => l.Product__c === product.Id && l.Integration__c === accountIntegration.Order_Integration__c && l.Name.includes('-FBA'))
        if(!existingFbaListing){
          listingsToCreate.push({
            Name: fbaName,
            Integration__c: accountIntegration.Order_Integration__c,
            Product__c: product.Id,
            SKU__c: `${sku}-FBA`,
            UPC__c: upc,
            Inventory_Status__c: 'Disabled',
            temp: {
              Product: product
            }
          })
        }
      }
    }
  }

  return listingsToCreate
}